var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_52_560",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_52_560",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAO3SURBVHic7Z3ddRoxEIWvcvIeUkFwBXEJpII4HeAOnErsVADuwB2YVGBcgekgUMHNgwRnvYddCSxpJDHfK7Aa5qKrv9kFUBRFURRFURTl0jC+N5BkjkBOZA1gA+AJwF9jzEY0mg9QqwB9lgB+G2O20oGcSisCAMAWwC9jzEo6kFP4JB1ARCYAnknOpQM5hZZ6QJcftfSEVgXYAriqYUxoyYK6TAA8SAcRQqs9YM9VzVPUIiE5JXlDckM/c+l4m4XkJECEJ+k4fVQ7BrgB9s7ztm85YrlYnB2NIh2jD+8gXDq+JBtjiv6O1VpQK6gAwqgAwkQXgOSC5CT2dZVA3OTjheR1xvaqnQVFp/Pd/+VYiaoAPY7kIKklqQA9BvKQzJJUgB4juUhiSSpAD19CGNmSVIAeAQKQES2pdgEkD2S2sKUky49cpPQk+/aiJFfCEwCL2JZUG6UcSa4B3Bpj1qd+UHtAHK5RYU1PDEoRAGjgbOIcPksH4HgFMD/HgmqnhB7wCGB2ickHZHvADsDdR6ehSo/AhdhaF2KJCEj+Mua8XwXoMZKLLXUzLj0DeYhmOYHtqQAdolpOQHsqgCOJ5Yy0pwIAh4Qks5yB9lSAPakt50h7KoAkuQSgLYdfxLpeM+QQgOQ17Sme9qg+qQUgOactKFBLO0YqAfaWk8rSmoCJbtDoWo4KMALtzXpjbM645jvLUQEGcBbx5hEg+CY9DliOCtCD1nZ+BiSfJH038e2vOWg5qQUopSoiFV99jyug3S65hy2TiY6vKqKUM+EUPI4ln3a1fg9gni2iI7TaA3YApkMC0O5TLWDLYZJSS11QbG5Gkj8H8IwMyQ+hRQFuA54VVEwNUksWtIP95a98b3QWtATwPXFMF2FBOwB/YD1/FfIBV4M0g61JEqWFHuCdao7hxoQHAF+iRdSh9EcleMmxMHILsbXEQqx4ciWEditiqQL0yJ0Q2s24rQrgkPhFcsSSUrRXNBICuHaPWlKq9opFSoBO++8sKXV7xSEtgIvhYEk52iuKEgRwcUxILmNft/hFgi/JtS90WtiKqBoVQBgVQJjqBWDljzmoQYBXz+uzHEGkogYBNp7X72vuBTUIsPK8PgXwQlsrNE0eTWSKn0O7pL5Jx3Eu1R9Jun/AED86TEXxPQA4zHQ2SHRsmJLqewBw+LOGG+k4UlCFAADgKh5upeOITRUW1IXkDPZPPKuwoyYsqIvrCVM0MjBX1wO6uCnqDHZ8mCJDpdup1L5driiKoiiKoihKfP4DxswuadcDmXsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.a88912050c58694d01c022d397dfd30e.svg";
export { ForwardRef as ReactComponent };